import React, { useState } from 'react';
import './CalculatorPage.css';

function AstrologyPoweredBusinessLaunchDateFinder() {
  const [month, setMonth] = useState('');
  const [year, setYear] = useState('');
  const [result, setResult] = useState(null);
  const [error, setError] = useState('');

  const findBestDate = (inputMonth, inputYear) => {
    // Placeholder for Astrology-Powered Business Launch Date Finder logic
    // This is a highly simplified example. Real astrological calculations are complex.
    if (!inputMonth || !inputYear) return null;

    const monthNum = parseInt(inputMonth, 10);
    const yearNum = parseInt(inputYear, 10);

    if (isNaN(monthNum) || isNaN(yearNum) || monthNum < 1 || monthNum > 12 || yearNum < 2024 || yearNum > 2050) {
      return null; // Invalid month or year
    }

    // Simple example: suggest a date based on numerology of month+year
    let sum = monthNum + yearNum;
    while (sum > 9) {
      sum = sum.toString().split('').reduce((s, d) => s + parseInt(d, 10), 0);
    }

    if (sum === 1 || sum === 5 || sum === 6) {
      return `Based on numerology, a date with a root number of ${sum} in ${inputMonth}/${inputYear} would be favorable for your business launch.`;
    } else {
      return `Based on numerology, a date with a root number of ${sum} in ${inputMonth}/${inputYear} has a neutral influence. Consult an astrologer for detailed insights.`;
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setError('');
    setResult(null);

    if (!month || !year) {
      setError('Please enter both month and year.');
      return;
    }

    const calculated = findBestDate(month, year);
    if (calculated === null) {
      setError('Invalid input. Please try again.');
    } else {
      setResult(calculated);
    }
  };

  const structuredData = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "Astrology-Powered Business Launch Date Finder",
    "description": "Find the most auspicious date for your business launch using astrological and numerological principles.",
    "url": "https://www.yourwebsite.com/astrology-powered-business-launch-date-finder",
    "potentialAction": {
      "@type": "SearchAction",
      "name": "Find Best Launch Date",
      "target": {
        "@type": "EntryPoint",
        "urlTemplate": "https://www.yourwebsite.com/astrology-powered-business-launch-date-finder?month={month}&year={year}",
        "actionPlatform": [
          "http://schema.org/DesktopWebPlatform",
          "http://schema.org/MobileWebPlatform"
        ]
      },
      "query-input": [
        "required name=month",
        "required name=year"
      ]
    }
  };

  return (
    <div className="calculator-page container my-8">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredData) }}
      />
      <h1 className="text-center text-primary">Astrology-Powered Business Launch Date Finder</h1>
      <p className="text-center">Find the most auspicious date for your business launch.</p>

      <form onSubmit={handleSubmit} className="calculator-form shadow-md rounded-lg p-6">
        <div className="form-group">
          <label htmlFor="month">Desired Launch Month (MM):</label>
          <input
            type="number"
            id="month"
            className="form-control"
            value={month}
            onChange={(e) => setMonth(e.target.value)}
            placeholder="e.g., 07"
            min="1"
            max="12"
          />
        </div>
        <div className="form-group">
          <label htmlFor="year">Desired Launch Year (YYYY):</label>
          <input
            type="number"
            id="year"
            className="form-control"
            value={year}
            onChange={(e) => setYear(e.target.value)}
            placeholder="e.g., 2025"
            min="2024"
            max="2050"
          />
        </div>
        {error && <p className="error-message">{error}</p>}
        <button type="submit" className="btn btn-primary">Find Best Date</button>
      </form>

      {result !== null && (
        <div className="result-section text-center my-8 p-6 shadow-md rounded-lg">
          <h2>Recommendation:</h2>
          <p className="result-explanation">{result}</p>
        </div>
      )}
    </div>
  );
}

export default AstrologyPoweredBusinessLaunchDateFinder;
